import { render, staticRenderFns } from "./InputEditorUpdated.vue?vue&type=template&id=63dae84f&scoped=true&"
import script from "./InputEditorUpdated.vue?vue&type=script&lang=js&"
export * from "./InputEditorUpdated.vue?vue&type=script&lang=js&"
import style0 from "./InputEditorUpdated.vue?vue&type=style&index=0&id=63dae84f&prod&lang=css&"
import style1 from "./InputEditorUpdated.vue?vue&type=style&index=1&id=63dae84f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dae84f",
  null
  
)

export default component.exports